import { ButtonsOptions, ColorOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../../config/component.config';
import { IPageComponentFullScreenHeroBannerData } from './full-screen-hero-banner.interface';

const isImageLayout = (data: IPageComponentFullScreenHeroBannerData) => data?.variant === 'image';
const isVideoLayout = (data: IPageComponentFullScreenHeroBannerData) => data?.variant === 'video';

export const config = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: 'full-screen-hero-banner',
    name: 'Full Screen Hero Banner',
    description: 'Full screen banner with image or video',
    tags: ['homepage', 'landing page'],
    fields: [
        // general
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IField>{
            key: 'link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link',
            description:
                'Please use path like /some-path for internal usage or absolute url https://example.com/some-page for external reference'
        },
        <NICmsContentField.IChoiceField>{
            key: 'variant',
            type: NICmsContentField.EFieldType.choice,
            title: 'Layout Variant',
            options: [
                { key: 'image', title: 'Image' },
                { key: 'video', title: 'Video' }
            ]
        },
        <NICmsContentField.IField>{
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            canShow: isImageLayout
        },
        // video
        <NICmsContentField.IField>{
            key: 'section-video',
            type: NICmsContentField.EFieldType.label,
            title: 'Video',
            canShow: isVideoLayout
        },
        <NICmsContentField.IField>{
            key: 'video_id',
            type: NICmsContentField.EFieldType.text,
            title: 'ID or URL',
            description: 'Vimeo ID or URL',
            canShow: isVideoLayout
        },
        <NICmsContentField.IField>{
            key: 'video_autoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Autoplay',
            default: true,
            canShow: isVideoLayout
        },
        <NICmsContentField.IField>{
            key: 'video_background',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Background Mode',
            default: true,
            canShow: isVideoLayout
        },
        // content
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'section-content',
            title: 'Content'
        },
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title'
        },
        <NICmsContentField.IField>{
            key: 'content',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Content'
        },
        <NICmsContentField.IChoiceField>{
            key: 'color',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Color',
            options: ColorOptions,
            colorPreview: true
        },
        <NICmsContentField.IField>{
            key: 'cta_text',
            type: NICmsContentField.EFieldType.text,
            title: 'Button Text',
            options: ButtonsOptions,
            default: ButtonsOptions[0] ? ButtonsOptions[0].key : undefined
        },
        <NICmsContentField.IChoiceField>{
            key: 'cta_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Button Style',
            options: ButtonsOptions,
            default: ButtonsOptions[0] ? ButtonsOptions[0].key : undefined
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};

export default config;
